module.exports = "<plans-page></plans-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/index.html
// module id = 1686
// module chunks = 0